import loadable from 'core/hoc/loadable';

export default loadable(() => import('./TelehealthBookingModal'));
